import { Check, X } from "lucide-react";
import {
  type WorkflowStepUserResponse,
  WorkflowStepUserResponses,
} from "~/api/types";

export function ActionIndicator({
  response,
}: {
  response: WorkflowStepUserResponse;
}) {
  switch (response) {
    case WorkflowStepUserResponses.approved:
      return (
        <span className="flex items-center text-emerald-700">
          <Check className="h-3 w-3" />
        </span>
      );
    case WorkflowStepUserResponses.rejected:
      return (
        <span className="flex items-center text-red-700">
          <X className="h-3 w-3" />
        </span>
      );
    case WorkflowStepUserResponses.pending:
      return (
        <span className="inline-block h-2 w-2 rounded-full bg-amber-600" />
      );
  }
}
